var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 551"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#E40425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 6576",
    d: "M16.2429 17.586L12.875 14.7748C12.6411 14.5798 12.2981 14.5732 12.0574 14.7598L8.2969 17.6656C7.87606 17.9908 7.25555 17.6997 7.25555 17.1771V7.26346C7.25555 6.9192 7.54322 6.63965 7.89739 6.63965H16.6602C17.0144 6.63965 17.3021 6.9192 17.3021 7.26346V17.1115C17.3029 17.6458 16.6594 17.9336 16.2429 17.586V17.586Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileHeader);
export default __webpack_public_path__ + "static/media/icon-profile-header.e71cedffcdf5ede658ef2cbbcb7da2b7.svg";
export { ForwardRef as ReactComponent };